import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { EnumTipoValor } from "@/Models/Domain/Viagem/Inscricao/InscricaoDesconto";

export interface IDescontoTipoValorSelectProps extends ISelectComPesquisaProps {

}

export default function DescontoTipoValorSelect({
    placeholder,
    ...rest
}:IDescontoTipoValorSelectProps) {
    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder === undefined ? "Selecione" : placeholder}
        options={[
            {
                value: EnumTipoValor.PercValor,
                label: "Percentual (%)",
            },
            {
                value: EnumTipoValor.ValorFixo,
                label: "Valor fixo (R$)",
            }
        ]}
    />
}